import KeyboardContainer from "components/common/Keyboard/Keyboard.container";
import { SyntheticEvent, useState } from "react";

export default function useKeyboardForm<T>(initialInputFields: T) {
  const keyboardContainer = KeyboardContainer.useContainer();
  const [inputFields, setInputFields] = useState<T>(initialInputFields);

  const onChange = (
    value: string,
    name: string = keyboardContainer.inputName
  ) => {
    setInputFields({ ...inputFields, [name]: value });
  };

  const clearKeyboardForm = () => {
    setInputFields(initialInputFields);
  };

  const onFocusIn = (event: SyntheticEvent<HTMLInputElement>) => {
    if (!event.currentTarget.name) {
      console.error("Input needs to have a name to work with keyboard.");
    }
    keyboardContainer.onInputFieldFocus(event.currentTarget.name);
  };

  return {
    inputFields,
    setInputFields,
    onChange,
    clearKeyboardForm,
    onFocusIn
  };
}



// WEBPACK FOOTER //
// ./src/components/common/Keyboard/Keyboard.hooks.ts